import PropTypes from 'prop-types';
import { Chip, Stack } from '@mui/material';
// utils
import { getMatchBadges } from '../../utils/duplicateMatchBadges';

/**
 * Chips explaining WHY two leads are considered the same person
 * (email/phone/visitor id) and whether attribution history is involved.
 */
const MatchBadges = ({ leadA, leadB, size = 'small', sx }) => {
    const badges = getMatchBadges(leadA, leadB);
    if (badges.length === 0) return null;

    return (
        <Stack direction='row' flexWrap='wrap' gap={0.5} sx={sx}>
            {badges.map((badge) => (
                <Chip key={badge} label={badge} size={size} variant='outlined' />
            ))}
        </Stack>
    );
};

MatchBadges.propTypes = {
    leadA: PropTypes.object,
    leadB: PropTypes.object,
    size: PropTypes.string,
    sx: PropTypes.object,
};

export default MatchBadges;
